module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page dashboard-page side-space"
  }, [_c('dashboard-nav', {
    attrs: {
      "name": "dashboard"
    }
  }), _vm._v(" "), _c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "innerBold",
      on: {
        "click": function($event) {
          _vm.setTopMenu(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "relative mt-70"
  }, [_c('div', {
    staticClass: "chart-parent"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": ""
    }
  }, [_c('div', {
    staticClass: "dashboard-title mb-1"
  }, [_vm._v(_vm._s(_vm.activeTab === 'topCreators' ? 'Top Creators' : 'Overview'))]), _vm._v(" "), (_vm.activeTab !== 'topCreators') ? _c('v-layout', {
    staticClass: "inner-tab-actions",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.getInnerTab()), function(action, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "inner-tab-action",
      class: [{
        'inner-tab-active': _vm.isActiveInnerTab(action.id)
      }, action.size == 'custom' ? 'custom-lg5' : action.size ? ("sm" + (action.size)) : ''],
      attrs: {
        "xs12": ""
      },
      on: {
        "click": function($event) {
          _vm.setChartDetails(action)
        }
      }
    }, [_c('div', {
      staticClass: "action_content"
    }, [_c('div', {
      staticClass: "action_title"
    }, [_vm._v(_vm._s(action.title))]), _vm._v(" "), _c('div', {
      staticClass: "action_value"
    }, [(typeof action.value == 'number') ? _c('span', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(action.value)))]) : _c('span', [_vm._v(_vm._s(action.value))])])])])
  })) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.activeTab === 'topCreators') ? _c('div', {
    staticClass: "col-summary-section"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, _vm._l((_vm.getDataTables()[0].data), function(creator, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "top-creator-item",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "top-creator-frame"
    }, [_c('div', {
      staticClass: "top-creator-avatar"
    }, [_c('img', {
      attrs: {
        "src": creator.avatar,
        "alt": "creator avatar"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "top-creator-details"
    }, [_c('div', {
      staticClass: "top-creator-name"
    }, [_vm._v(_vm._s(creator.name))]), _vm._v(" "), _c('div', {
      staticClass: "top-creator-plays"
    }, [_vm._v(_vm._s(creator.plays))])]), _vm._v(" "), _c('div', {
      staticClass: "top-creator-earnings"
    }, [_vm._v(_vm._s(creator.earnings))])])])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getSummaryTabs()) ? _c('div', {
    staticClass: "col-summary-section"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, _vm._l((_vm.getSummaryTabs()), function(col, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "sm12": "",
        "lg4": "",
        "custom-lg3plus": "",
        "col-summary": ""
      }
    }, [_c('div', {
      staticClass: "col-summary-frame"
    }, [_c('div', {
      staticClass: "col-summary-frame-header"
    }, [_c('h4', [_vm._v(_vm._s(col.header))])]), _vm._v(" "), (col.type == 'pie') ? _c('div', {
      staticClass: "col-summary-frame-body chart-body"
    }, [_c('div', {
      staticClass: "pie-chart",
      attrs: {
        "id": "chart"
      }
    }, [_c('chart', {
      attrs: {
        "type": "donut",
        "height": "500",
        "options": _vm.pieChartOptions,
        "series": _vm.pieSeries
      }
    })], 1)]) : _c('div', {
      staticClass: "col-summary-frame-body"
    }, _vm._l((7), function(item, i) {
      return _c('div', {
        key: i,
        staticClass: "col-listing",
        class: [col.avatarType == 'square' ? '__square' : col.avatarType == 'round' ? '__round' : col.avatarType == 'rectangle' ? '__rectangle' : '']
      }, [_c('div', {
        staticClass: "_title"
      }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('div', {
        staticClass: "_thumbnail"
      }), _vm._v(" "), _c('div', {
        staticClass: "d-flex flex-column"
      }, [_c('div', {
        staticClass: "_title"
      }, [_vm._v("First Last")]), _vm._v(" "), _c('div', {
        staticClass: "_subtitle"
      }, [_vm._v("RUCKAZOID, Tri Nohbi")])])])
    }))])])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getStatsList()) ? _c('v-container', {
    attrs: {
      "px-0": "",
      "mw-100": ""
    }
  }, [_c('div', {
    staticClass: "tracks-title mt-2"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getStatsList().title))])]), _vm._v(" "), _vm._l((_vm.getStatsList().items), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "tracks-user-title"
    }, [_c('div', {
      staticClass: "tracks-user-title__item"
    }, [_c('div', {
      staticClass: "item-image"
    }, [(_vm.getStatsList().items_type == 'musics') ? _c('img', {
      attrs: {
        "src": item.album.cover.url
      }
    }) : (_vm.getStatsList().items_type == 'products') ? _c('img', {
      attrs: {
        "src": item.cover.url
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "d-flex flex-column gap-4"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(item.user.display_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "tracks-info"
    }, [_c('div', {
      staticClass: "tracks-info-right"
    }, [_c('v-layout', {
      staticClass: "inner-tab-actions",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.totalTrackList), function(item, i) {
      return _c('v-flex', {
        key: i,
        staticClass: "inner-tab-action",
        class: i > 3 ? 'sm4' : 'sm3',
        attrs: {
          "xs12": ""
        }
      }, [_c('div', {
        staticClass: "action_content track-item"
      }, [_c('div', {
        staticClass: "action_title"
      }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
        staticClass: "action_value"
      }, [_c('span', [_vm._v(_vm._s(item.content))])])])])
    }))], 1)])])
  })], 2) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9479c088","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/index.vue
// module id = 1815
// module chunks = 180